// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement, color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

interface OrderTotalDisplaySharedStyles {
    mainContainer: GridContainerProps;
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelGridItem: GridItemProps;
    valueGridItem: GridItemProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    styledHr?: InjectableCss;
    wrapper?: InjectableCss;
}

const label: TypographyPresentationProps = {
    size: 14,
    weight: "normal",
    css: css`
        letter-spacing: 0;
        line-height: ${fontConfig.lineHeight.small};
    `,
};
const value: TypographyPresentationProps = {
    size: 14,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: ${fontConfig.lineHeight.small};
        margin-left: auto;
    `,
};
export const orderTotalDisplaySharedStyles: OrderTotalDisplaySharedStyles = {
    mainContainer: {
        gap: 0,
        offsetCss: css`
            row-gap: 8px;
        `,
    },
    titleText: {
        variant: "h5",
        forwardAs: "h2",
        css: css`
            margin: 0;
        `,
    },
    labelGridItem: {
        width: 7,
    },
    valueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 5,
    },
    label: {
        ...label,
    },
    value: {
        ...value,
    },
    totalLabel: {
        ...label,
    },
    totalValue: {
        ...value,
    },
    styledHr: {
        css: css`
            width: 100%;
            border: none;
            border-bottom: 1px solid ${color("common.border")};
            margin: 0 0 5px 0;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            ${avoidBreakInsidePrintElement}
        `,
    },
};
